import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import * as routes from '../constants/routes';
import { Header, Lazy } from '../components/base';
import { useSelector } from 'react-redux';
import {
  isAuthorized as useAuthorized,
  permission as usePermission,
} from 'store/auth/selector';
import Dashboard from 'layouts';
import routeItems from './routes';

export const ClientRouter: React.FC = () => {
  const isAuthorized = useSelector(useAuthorized);
  const permission = useSelector(usePermission) || [];
  const isDriverPermission =
    permission?.some((item: any) => item?.description === 'delivery.index') &&
    true;

  const isDashBoardPermission =
    permission?.some((item: any) => item?.description === 'dashboard.index') &&
    true;

  const PrivateAdminRoute: React.FC<{ children: React.ReactNode }> = ({
    children,
  }) => {
    if (!isAuthorized) {
      return (
        <Navigate
          to={routes.LOGIN}
          replace
        />
      );
    }
    return <>{children}</>;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={routes.LOGIN}
          element={<Lazy page='Login' />}
        />
        <Route
          path='/'
          element={
            <PrivateAdminRoute>
              <Dashboard />
            </PrivateAdminRoute>
          }
        >
          {routeItems.map((route, key) => {
            const isPermission = route?.policy
              ? permission?.some(
                  (item: any) => item?.description === route?.policy
                )
              : true;

            return (
              <Route
                path={route?.path}
                index
                key={key}
                element={
                  isDashBoardPermission ? (
                    isPermission ? (
                      route?.component ? (
                        <Lazy page={route.component} />
                      ) : null
                    ) : (
                      <Lazy page='UnAuthorized' />
                    )
                  ) : isDriverPermission ? (
                    <Lazy page={'Delivery'} />
                  ) : (
                    <Lazy page='UnAuthorized' />
                  )
                }
              />
            );
          })}
        </Route>
        <Route
          path='*'
          element={<Lazy page='NotFound' />}
        />
      </Routes>
    </BrowserRouter>
  );
};
